import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, FormGroupDirective } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';
import { VariantenHvComponent } from './varianten-hv/varianten-hv.component';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from '../../service/popup.service';
import { MessageService } from '../../service/message.service';
import { IPraemieStatus, PraemienStatus } from '../../../shared/praemie';
import { ZahlungsartHvComponent } from './zahlungsart-hv/zahlungsart-hv.component';
import { OffertComponent } from '../offert/offert.component';
import { VereinbarungKommunikationComponent } from '../vereinbarung-kommunikation/vereinbarung-kommunikation.component';
import { DatenschutzPolicyComponent } from '../datenschutz-policy/datenschutz-policy.component';
import { debounce, first } from 'rxjs/operators';
import { interval, merge, Observable, ReplaySubject, Subject, zip } from 'rxjs';
import {
    addRemoveFormArray,
  getExpertMode,
  getOffertAntrag,
  getOffertBase,
  getOffertBaseId,
  getPartner,
  getPartnerId,
  getQuery,
  getVerifyOffert,
} from '../../../shared/utils';
import { HttpErrorResponse } from '@angular/common/http';
import { CalculationService } from '../../service/calculation.service';
import { OffertService } from '../../service/offert.service';
import { AntragWeitereFragenComponent } from '../antrag/antrag-weitere-fragen/antrag-weitere-fragen.component';
import { AntragComponent } from '../antrag/antrag.component';
import { DatenBeratungsprotokollComponent } from '../daten-beratungsprotokoll/daten-beratungsprotokoll.component';
import { DataService } from '../../service/data.service';
import { AntragService } from '../../service/antrag.service';
import { CurrentRechner } from '../../../shared/rechner';
import { OffertVerificationDialogService } from '../../service/offert-verification-dialog.service';
import { OffertBaseService } from '../../service/offert.base.service';
import { ErrorMessageType, HeimvorteilGebaeudeart, HeimvorteilProduktart, ProduktArt } from '../../../shared/enum';
import { EnumService } from '../../service/enum.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { CalculateHvDatenComponent } from './calculatehv-daten/calculatehv-daten.component';
import { CalculateHvErweiterungenComponent} from './calculatehv-erweiterungen/calculatehv-erweiterungen.component';
import { CalculateHvZusatzpaketeComponent } from './calculatehv-zusatzpakete/calculatehv-zusatzpakete.component';
import {IHvPaket} from '../../models/hvpaket';
import {MatStepper} from '@angular/material/stepper';
import { IHvProdukt } from '../../models/hvprodukt';
import { IHvResult } from '../../models/hvresult';
import {HvAntragComponent} from '../antrag/hv-antrag/hv-antrag.component';
import {IHvAntrag} from '../../models/hvantrag';
import {IHvOffert} from '../../models/hvoffert';
import { ErhoehungHoechsthaftungssummeComponent } from '../erhoehung-hoechsthaftungssumme/erhoehung-hoechsthaftungssumme.component';
import {HvZusammenfassungComponent} from '../zusammenfassung/hv-zusammenfassung/hv-zusammenfassung.component';
import {CalculateRateOptions} from '../../models/calculateRateOptions';
import { ProcessingService } from '../../service/processing.service';
import { FriendlycaptchaWidgetComponent } from '../friendlycaptcha-widget/friendlycaptcha-widget.component';
import { CalculateComponent } from '../calculate/calculate.component';


@Component({
  selector: 'app-calculatehv',
  templateUrl: './calculatehv.component.html',
  styleUrls: ['./calculatehv.component.scss']
})
export class CalculatehvComponent extends CalculateComponent implements OnInit, AfterViewInit {

  @ViewChild('firstFormGroupDirective') firstFormGroupDirective: FormGroupDirective;
  @ViewChild('extensionFormGroupDirective') extensionFormGroupDirective: FormGroupDirective;
  @ViewChild('packageFormGroupDirective') packageFormGroupDirective: FormGroupDirective;
  @ViewChild('secondFormGroupDirective') secondFormGroupDirective: FormGroupDirective;
  @ViewChild('thirdFormGroupDirective') thirdFormGroupDirective: FormGroupDirective;
  @ViewChild('fourthFormGroupDirective') forthFormGroupDirective: FormGroupDirective;
  @ViewChild('fifthFormGroupDirective') fifthFormGroupDirective: FormGroupDirective;

  @ViewChild(VariantenHvComponent) variantenHvComponent: VariantenHvComponent;
  @ViewChild(CalculateHvDatenComponent) calculateHvDatenComponent: CalculateHvDatenComponent;
  @ViewChild(CalculateHvErweiterungenComponent) calculateHvErweiterungenComponent: CalculateHvErweiterungenComponent;
  @ViewChild(CalculateHvZusatzpaketeComponent) calculateHvZusatzpaketeComponent: CalculateHvZusatzpaketeComponent;
  @ViewChild(ZahlungsartHvComponent) zahlungsartHhComponent: ZahlungsartHvComponent;

  @ViewChild(AntragComponent) antragComponent: AntragComponent;
  @ViewChild(HvAntragComponent) hvAntragComponent: HvAntragComponent;
  @ViewChild(HvZusammenfassungComponent) hvZusammenfassungComponent: HvZusammenfassungComponent;

  @ViewChild('_erhoehungHoechsthaftungssummeHaushalt') erhoehungHoechsthaftungssummeHaushaltComponent: ErhoehungHoechsthaftungssummeComponent;
  @ViewChild('_erhoehungHoechsthaftungssummeEigenheim') erhoehungHoechsthaftungssummeEigenheimComponent: ErhoehungHoechsthaftungssummeComponent;
  @ViewChildren('_erhoehungHoechsthaftungssummeNebengebaeude') erhoehungHoechsthaftungssummeNebengebaeudeComponents: QueryList<ErhoehungHoechsthaftungssummeComponent>;

  @ViewChildren('angebotTeaser', { read: ElementRef }) angebotTeaserList: QueryList<ElementRef>;
  @ViewChildren('antragTeaser', { read: ElementRef }) antragTeaserList: QueryList<ElementRef>;

  @ViewChild(OffertComponent) offertComponent: OffertComponent;

  @ViewChild('variantPanel') variantPanel: MatExpansionPanel;
  @ViewChild('dataPanel') dataPanel: MatExpansionPanel;
  @ViewChild('stepper') private stepper: MatStepper;

  variantFormGroup: UntypedFormGroup;
  firstFormGroup: UntypedFormGroup;
  // TODO maybe rename the form groups as we get new sections for "Erweiterungen" und "Zusatzpakete"
  extensionFormGroup: UntypedFormGroup;
  packageFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;
  fourthFormGroup: UntypedFormGroup;
  fifthFormGroup: UntypedFormGroup;

  hvResult: IHvResult = {} as IHvResult;

  /*
  hvResult: IHvResult = {
    HoechsthaftungssummeEigenheim: 33600,
    HoechsthaftungssummeHaushalt: 13104,
    Hoechsthaftungssumme: 46407,
    Halbjahrespraemie: 16,
    Vierteljahrespraemie: 8,
    Monatspraemie: 2,
    Gesamt: 32,
    Nebengebaeude: Array<INebengebaeudeResult>(
      {
        GebaeudeArt: 'Carport',
        TarifVersicherungssumme: 25500,
        Hoechsthaftungssumme: 25500
      },
      {
        GebaeudeArt: 'Garage',
        TarifVersicherungssumme: 33750,
        Hoechsthaftungssumme: 33750
      },
      {
        GebaeudeArt: 'Gartenhaus',
        TarifVersicherungssumme: 65250,
        Hoechsthaftungssumme: 65250
      },
      {
        GebaeudeArt: 'Poolhaus',
        TarifVersicherungssumme: 24750,
        Hoechsthaftungssumme: 24750
      },
      {
        GebaeudeArt: 'Sonstiges',
        TarifVersicherungssumme: 42000,
        Hoechsthaftungssumme: 42000
      })
  } as IHvResult;
  */

  praemie: IPraemieStatus;

  initializeForm$ = new Subject();
  calculateRate$ = new Subject<CalculateRateOptions>();
  loadPakets$ = new Subject();
  resultAvailable$ = new Subject();
  createOffert$ = new Subject();
  createAntrag$ = new Subject();

  expertMode: boolean;
  offertBaseId: number;
  offertBase: boolean;
  partnerId: number;
  partner: boolean;
  verifyOffert: boolean;
  offertAntrag: boolean;

  korrektur = false;
  kuendigungRisiken = false;
  produktArten = ProduktArt;

  hvHaushaltPakete = new ReplaySubject<Array<IHvPaket>>();
  hvEigenheimPakete = new ReplaySubject<Array<IHvPaket>>();

  calculateRatePending = true;
  calculatingRate = false;
  maxVersicherungsSummeUeberschritten = false;

  antragVersicherungsnehmer: UntypedFormGroup;
  offertVersicherungsnehmer: UntypedFormGroup;

  @ViewChild('thirdFormGroupFriendlycaptchaWidget') thirdFormGroupFriendlycaptchaWidgetComponent: FriendlycaptchaWidgetComponent;
  @ViewChild('fifthFormGroupFriendlycaptchaWidget') fifthFormGroupFriendlycaptchaWidgetComponent: FriendlycaptchaWidgetComponent;

  constructor(private route: ActivatedRoute, private currentRechner: CurrentRechner, private fb: UntypedFormBuilder, public translateService: TranslateService,
              public popupService: PopupService, private praemienStatus: PraemienStatus, private calculationService: CalculationService, private offertService: OffertService,
              public antragService: AntragService, public dataService: DataService, private ref: ChangeDetectorRef, private offertBaseService: OffertBaseService,
              private offertVerificationDialogService: OffertVerificationDialogService, private enumService: EnumService, private messageService: MessageService,
              private processingService: ProcessingService) {

    super();

    this.expertMode = getExpertMode(this.route);
    this.offertBaseId = getOffertBaseId(this.route);
    this.offertBase = getOffertBase(this.route);
    this.partnerId = getPartnerId(this.route);
    this.partner = getPartner(this.route);
    this.verifyOffert = getVerifyOffert(this.route);
    this.offertAntrag = getOffertAntrag(this.route);

    this.currentRechner.setRechner('Haushalts- und Eigenheimrechner');
    this.currentRechner.setProduktseite('https://www.hdi.at/privat/produkte/haushaltsversicherung.php');

    this.calculateRate$
      .pipe(debounce(() => interval(300)))
      .subscribe((options) => {
        this.calculateRate(options);
      });

    this.createOffert$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.createOffert();
      });

    this.createAntrag$
      .pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.createAntrag();
      });

    this.loadPakets$.pipe(debounce(() => interval(300)))
      .subscribe(() => {
        this.loadHvPakete();
      });

    this.offertVerificationDialogService.loadOffert$
      .subscribe((data) => {

        const offert = data as IHvOffert;
        this.setProdukt(offert.Produkt);
        const anlagedatum = offert.Anlagedatum;
        const versicherungsnehmer = offert.Versicherungsnehmer;

        this.ref.detectChanges();

        this.antragComponent.versicherungsnehmerComponent.setPartner(versicherungsnehmer);
        if (!this.expertMode) {
          this.popupService.openOffertAntragInfoPopup(
            versicherungsnehmer, anlagedatum, offert.Produkt.Varianten.Produktart === HeimvorteilProduktart.Eigenheim ? 'Eigenheimversicherung' :
              offert.Produkt.Varianten.Produktart === HeimvorteilProduktart.Haushalt ? 'Haushaltsversicherung' :
                offert.Produkt.Varianten.Produktart === HeimvorteilProduktart.Buendel ? 'Haushalts- und Eigenheimversicherung' : null);
        }
      });

    this.initializeForm$
      .subscribe(() => {
        this.initializeForm();
      });
  }

  ngOnInit(): void {
    this.variantFormGroup = this.fb.group({
      produktart: VariantenHvComponent.createProduktart(),
      gebaeudeart: VariantenHvComponent.createGebaeudeart()
    });

    this.firstFormGroup = CalculateHvDatenComponent.createFormGroup(this.fb);
    this.extensionFormGroup = CalculateHvErweiterungenComponent.createFormGroup(this.fb);
    this.packageFormGroup = CalculateHvZusatzpaketeComponent.createFormGroup(this.fb);

    this.secondFormGroup = this.fb.group({
      zahlungsart: ZahlungsartHvComponent.createZahlungsart(),
      erhoehungHoechsthaftungssummeHaushaltGroup: ErhoehungHoechsthaftungssummeComponent.createFormGroup(this.fb, this.expertMode, HeimvorteilProduktart.Haushalt),
      erhoehungHoechsthaftungssummeEigenheimGroup: ErhoehungHoechsthaftungssummeComponent.createFormGroup(this.fb, this.expertMode, HeimvorteilProduktart.Eigenheim),
      erhoehungHoechsthaftungssummeNebengebaeudeGroups: this.fb.array([])
    });

    this.thirdFormGroup = this.fb.group({
      offert: OffertComponent.createFormGroup(this.fb, this.expertMode),
      vereinbarungKommunikation: VereinbarungKommunikationComponent.createVereinbarungKommunikation(),
      datenschutzPolicy: DatenschutzPolicyComponent.createDatenschutzPolicy()
    });

    this.fourthFormGroup = this.fb.group({
      antrag: AntragComponent.createFormGroup(this.fb, this.expertMode),
      hvAntrag: HvAntragComponent.createFormGroup(this.fb),
      datenBeratungsprotokoll: DatenBeratungsprotokollComponent.createFormGroup(this.fb),
      antragWeitereFragen: AntragWeitereFragenComponent.createFormGroup(this.fb),
    });

    this.fifthFormGroup = this.fb.group({
      hvZusammenfassung: HvZusammenfassungComponent.createFormGroup(this.fb),
      datenschutzPolicy: DatenschutzPolicyComponent.createDatenschutzPolicy()
      });

    this.ref.detectChanges();

    this.onValueChanged();
    this.toggleEditMode();

    if (this.offertBase) {
      this.loadOffertBase();
    } else if (this.verifyOffert) {
      this.verifyOffertLink();
    } else {
      this.initializeForm$.next();
    }

    /*
    this.erhoehungHoechsthaftungssummeNebengebaeudeGroups.clear();
    this.hvResult.Nebengebaeude.forEach(() => {
      this.erhoehungHoechsthaftungssummeNebengebaeudeGroups.push(ErhoehungHoechsthaftungssummeComponent.createFormGroup(this.fb, this.expertMode));
    });
    */

    this.antragVersicherungsnehmer = this.antragComponent?.versicherungsnehmerComponent.formGroup;
    this.offertVersicherungsnehmer = this.offertComponent?.versicherungsnehmerComponent.formGroup;
  }

  ngAfterViewInit() {
    this.angebotTeaserList.changes.subscribe(() => {
      if (this.angebotTeaserList.length > 0) {
        (this.angebotTeaserList.first.nativeElement as HTMLElement).scrollIntoView();
      }
    });
    this.antragTeaserList.changes.subscribe(() => {
      if (this.antragTeaserList.length > 0) {
        (this.antragTeaserList.first.nativeElement as HTMLElement).scrollIntoView();
      }
    });
  }

  initializeForm() {

    if(this.expertMode) {
      // Berechnungsangaben
      this.staendigBewohnt.setValue('ja');
      this.ref.detectChanges();

      // Prämiennachlässe
      this.selbstbehalt.setValue('nein');
    }
    this.zahlungsartHhComponent.setZahlungsart(1);  // jaehrlich
  }

  // get produktart() { return this.variantFormGroup.get('produktart'); }
  // get gebaeudeart() { return this.variantFormGroup.get('gebaeudeart'); }
  get zahlungsart() { return this.secondFormGroup.get('zahlungsart'); }
  get selbstbehalt() { return this.secondFormGroup.get('selbstbehalt'); }
  get staendigBewohnt() { return this.firstFormGroup.get('staendigBewohnt'); }
  get hoechsthaftungssumme() { return this.firstFormGroup.get('hoechsthaftungssummeGroup')?.get('hoechsthaftungssumme'); }
  get hoechsthaftungssummeNebengebaeude() { return this.firstFormGroup.get('hoechsthaftungssummeNebengebaeudeGroup')?.get('hoechsthaftungssumme'); }
  get vereinbarungKommunikationOffert() { return this.thirdFormGroup.get('vereinbarungKommunikation'); }
  get offert() { return this.thirdFormGroup.get('offert'); }
  get datenschutzPolicyOffert() { return this.thirdFormGroup.get('datenschutzPolicy'); }
  get antrag() { return this.fourthFormGroup.get('antrag'); }
  get hvAntrag() { return this.fourthFormGroup.get('hvAntrag'); }
  get datenBeratungsprotokoll() { return this.fourthFormGroup.get('datenBeratungsprotokoll'); }
  get antragWeitereFragen() { return this.fourthFormGroup.get('antragWeitereFragen'); }
  get datenschutzPolicyAntrag() { return this.fifthFormGroup.get('datenschutzPolicy'); }
  get hvZusammenfassung() { return this.fifthFormGroup.get('hvZusammenfassung');}
  get erhoehungHoechsthaftungssummeHaushaltGroup() { return this.secondFormGroup.get('erhoehungHoechsthaftungssummeHaushaltGroup'); }
  get erhoehungHoechsthaftungssummeEigenheimGroup() { return this.secondFormGroup.get('erhoehungHoechsthaftungssummeEigenheimGroup'); }
  get erhoehungHoechsthaftungssummeNebengebaeudeGroups() { return this.secondFormGroup.get('erhoehungHoechsthaftungssummeNebengebaeudeGroups') as UntypedFormArray; }

  get interesseHaushaltsversicherung() {
    // TODO put this in the data component?
    return true;
    //return this.gebaeudeArt.value && (!this.showEigenheimversicherung || this.eigenheimversicherung.value === 'nein') ? true : false;
  }

  /*
  get isHH() {
    return this.produktart.value && this.produktart.value === HeimvorteilProduktart.Haushalt.toString()  ? true : false;
  }

  get isEH() {
    return this.produktart.value && this.produktart.value === HeimvorteilProduktart.Eigenheim.toString() ? true : false;
  }

  get isBuendel() {
    return this.produktart.value && this.produktart.value === HeimvorteilProduktart.Buendel.toString() ? true : false;
  }
  */

  get showAngebotTeaser() {
    return this.pdfDataOffert &&
      this.variantFormGroup.valid &&
      this.firstFormGroup.valid &&
      this.extensionFormGroup.valid &&
      this.packageFormGroup.valid &&
      this.secondFormGroup.valid &&
      this.thirdFormGroup.valid &&
      !this.calculateRatePending &&
      !this.calculatingRate;
  }
  get showAntragTeaser() {
    return this.pdfDataAntrag &&
      this.variantFormGroup.valid &&
      this.firstFormGroup.valid &&
      this.extensionFormGroup.valid &&
      this.packageFormGroup.valid &&
      this.secondFormGroup.valid &&
      this.fourthFormGroup.valid &&
      this.fifthFormGroup.valid &&
      !this.calculateRatePending &&
      !this.calculatingRate;
  }

  getOffert(): IHvOffert {
    return {
      ...this.offertComponent.getOffert(),
      Produkt: this.getProdukt()
    } as IHvOffert;
  }

  getAntrag(): IHvAntrag {
    const antrag =  {
      ...this.hvAntragComponent.getHvAntrag(),
      ...this.antragComponent.getAntrag(),
      BesondereAnmerkungen: this.hvZusammenfassungComponent.besondereAnmerkungen.value,
      ...this.hvAntragComponent.antragWeitereFragenComponent.getAntrag(),
      ...this.hvAntragComponent.datenBeratungsprotokollComponent.getOffertBase(),
      Versicherungsort: this.antragComponent.versicherungsortComponent.getAdresse(),
      Produkt: this.getProdukt()
    } as IHvAntrag;

    antrag.Produkt.Erweiterungen.HaftpflichtHunde = this.hvAntragComponent.haftpflichtHundeComponents
      .map(haftpflichtHundeComponent => (haftpflichtHundeComponent.getHaftpflichtHund()));
    antrag.Produkt.Erweiterungen.HaftpflichtWeiterePersonen = this.hvAntragComponent.haftpflichtPersonenComponents
      .map(haftpflichtPersonenComponent => (haftpflichtPersonenComponent.getHaftpflichtPerson()));

    return antrag;
  }

  getProdukt(): IHvProdukt {
    return {
      Varianten: this.variantenHvComponent.getVariante(),
      Daten: this.calculateHvDatenComponent.getDaten(
        this.erhoehungHoechsthaftungssummeNebengebaeudeComponents.map(item => (item.getHoechsthaftungssumme()))),
      Erweiterungen: this.calculateHvErweiterungenComponent.getErweiterungen(),
      PaketeEigenheim: this.calculateHvZusatzpaketeComponent.getZusatzpaketeEigenheim(),
      PaketeHaushalt: this.calculateHvZusatzpaketeComponent.getZusatzpaketeHaushalt(),
      HoechsthaftungssummeHaushalt: this.erhoehungHoechsthaftungssummeHaushaltComponent?.hoechsthaftungssummeFreieEingabe.value,
      HoechsthaftungssummeEigenheim: this.erhoehungHoechsthaftungssummeEigenheimComponent?.hoechsthaftungssummeFreieEingabe.value,
      ZahlungArtId: this.zahlungsartHhComponent.getZahlungsart(),
      ExpertMode: this.expertMode
    } as IHvProdukt;
  }

  setKuendigungRisiken(kuendigungRisiken: boolean) {
    this.kuendigungRisiken = kuendigungRisiken;
  }

  setProdukt(produkt: IHvProdukt) {
    return new Promise<void>(resolve => {

      this.variantenHvComponent.setVariante(produkt.Varianten);
      this.calculateHvDatenComponent.setDaten(produkt.Daten);
      this.calculateHvErweiterungenComponent.setErweiterungen(produkt.Erweiterungen);
      zip(this.hvHaushaltPakete, this.hvEigenheimPakete).pipe(first()).subscribe(() => {
        this.calculateHvZusatzpaketeComponent.setZusatzpakete(produkt.PaketeEigenheim.concat(produkt.PaketeHaushalt));
      });
      this.zahlungsartHhComponent.setZahlungsart(produkt.ZahlungArtId);

      this.resultAvailable$.pipe(first()).subscribe(() => {
        if (produkt.HoechsthaftungssummeHaushalt > 0) {
          this.erhoehungHoechsthaftungssummeHaushaltComponent?.erhoehungHoechsthaftungssumme.setValue('ja');
          this.erhoehungHoechsthaftungssummeHaushaltComponent?.setHoechsthaftungssumme(produkt.HoechsthaftungssummeHaushalt);
        } else {
          this.erhoehungHoechsthaftungssummeHaushaltComponent?.erhoehungHoechsthaftungssumme.setValue('nein');
        }
        if (produkt.HoechsthaftungssummeEigenheim > 0) {
          this.erhoehungHoechsthaftungssummeEigenheimComponent?.erhoehungHoechsthaftungssumme.setValue('ja');
          this.erhoehungHoechsthaftungssummeEigenheimComponent?.setHoechsthaftungssumme(produkt.HoechsthaftungssummeEigenheim);
        } else {
          this.erhoehungHoechsthaftungssummeEigenheimComponent?.erhoehungHoechsthaftungssumme.setValue('nein');
        }

        for (let i = 0; i < this.hvResult.Nebengebaeude.length; i++) {
          if (this.hvResult.Nebengebaeude[i].Hoechsthaftungssumme) {
            this.erhoehungHoechsthaftungssummeNebengebaeudeComponents.toArray()[i].erhoehungHoechsthaftungssumme.setValue('ja');
            this.erhoehungHoechsthaftungssummeNebengebaeudeComponents.toArray()[i].setHoechsthaftungssumme(this.hvResult.Nebengebaeude[i].TarifVersicherungssumme);
          }
        }

      });

      this.ref.detectChanges();
      resolve();
    });
  }

  setAntrag(antrag: IHvAntrag): void {
    this.setProdukt(antrag.Produkt).then( () => {
      this.hvAntragComponent.setHvAntrag(antrag);
      this.antragComponent.setAntrag(antrag);
      this.hvZusammenfassungComponent.besondereAnmerkungenComponent.setValue(antrag.BesondereAnmerkungen);
    });
  }

  setOffert(offert: IHvOffert): void {
    this.setProdukt(offert.Produkt).then(
      () => this.offertComponent.setOffert(offert)
    );
  }

  onValueChanged(): void {
    this.zahlungsartHhComponent.zahlungsart.valueChanges.subscribe(() => {
      if (!this.calculateRatePending) {
        this.praemienStatus.setPraemie(Number(this.zahlungsartHhComponent.zahlungsart.value.Key), this.getPraemieZahlungsart());
      }
    });
    this.firstFormGroup.valueChanges.subscribe(() => {
      this.resetPdfData()
    });
    merge(
      this.firstFormGroup.valueChanges,
      this.secondFormGroup.valueChanges,
      this.thirdFormGroup.valueChanges,
      this.fourthFormGroup.valueChanges,
      this.fifthFormGroup.valueChanges
    ).subscribe(() => {
      this.resetPdfData()
    });
  }

  loadOffertBase(): void {
    this.offertBaseService.getOffertBase(getQuery(), this.offertBaseId).subscribe(
      data => {
        if (data.LinkIsValid) {
          const offertBase = data.OffertBase;
          if (offertBase.Antrag === true) {
            const hvAntrag = offertBase as IHvAntrag;
            hvAntrag.Produkt.Daten.Beginndatum = hvAntrag.Beginndatum;
            this.setAntrag(hvAntrag);
          } else {
            const hvOffert = offertBase as IHvOffert;
            if (this.offertAntrag) {
              this.setProdukt(hvOffert.Produkt);
              this.antragComponent.versicherungsnehmerComponent.setPartner(offertBase.Versicherungsnehmer);
            } else {
              this.setOffert(hvOffert);
            }
          }
        } else {
          window.location.href = data.RedirectUrl;
        }
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.OffertLoad));
        console.log(err.message);
      }
    );
  }

  createOffert(): void {
    this.processingService.execute(
      (): boolean => this.variantFormGroup.valid && this.firstFormGroup.valid && this.extensionFormGroup.valid && this.packageFormGroup.valid && this.thirdFormGroup.valid,
      (): Observable<any> => this.offertService.createHvOffert(this.getOffert(), getQuery(),
        this.thirdFormGroupFriendlycaptchaWidgetComponent.getSolution()),
      (data: any): void => {
        this.pdfDataOffert = data;
      },
      (err: HttpErrorResponse): void => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.OffertCreate));
        console.log(err.message);
      }
    );
  }

  createAntrag(): void {
    this.processingService.execute(
      (): boolean => this.variantFormGroup.valid && this.firstFormGroup.valid && this.extensionFormGroup.valid &&
        this.packageFormGroup.valid && this.fourthFormGroup.valid && this.fifthFormGroup.valid,
      (): Observable<any> => this.antragService.createHvAntrag({ ...this.getAntrag(), Eingereicht: false }, getQuery(),
        this.fifthFormGroupFriendlycaptchaWidgetComponent.getSolution()),
      (data: any): void => {
        this.pdfDataAntrag = data;
      },
      (err: HttpErrorResponse): void => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.AntragCreate));
        console.log(err.message);
      }
    );
  }

  calculateRate(options: CalculateRateOptions): void {
    if (this.variantFormGroup.valid && this.firstFormGroup.valid && ((this.extensionFormGroup.valid && this.packageFormGroup.valid) || (options && options.precalc))) {
      this.calculatingRate = true;
      this.calculationService.calculateHvRate(this.getProdukt(), getQuery()).subscribe(
        data => {
          this.hvResult = data;
          this.praemienStatus.setPraemie(
            this.zahlungsartHhComponent.zahlungsart.value ? Number(this.zahlungsartHhComponent.zahlungsart.value.Key) : 1, this.getPraemieZahlungsart());
          addRemoveFormArray(this.erhoehungHoechsthaftungssummeNebengebaeudeGroups, data.Nebengebaeude.length,
            (): UntypedFormGroup => { return ErhoehungHoechsthaftungssummeComponent.createFormGroup(this.fb, this.expertMode, HeimvorteilProduktart.Eigenheim); });
          this.ref.detectChanges();
          this.calculateRatePending = false;
          this.calculatingRate = false;
          this.resultAvailable$.next();

          if(this.hvResult.TarifVersicherungssummeEigenheim > 1000000){
            this.maxVersicherungsSummeUeberschritten = true;
          }
          if (options && options.precalc && !this.maxVersicherungsSummeUeberschritten){
            this.stepper.next();
          }
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.CalculateRate));
          console.log(err.message);
        }
      );
    }
  }

  toggleEditMode(): void {
  }

  verifyOffertLink(): void {
    this.offertService.verifyOffertLink(getQuery()).subscribe(
      (data) => {
        if (data.LinkIsValid === true) {
          this.offertVerificationDialogService.openDialog(data.Privatperson);
        } else {
          this.translateService.get('OFFERTVERIFICATIONLINKEXPIREDINFO').subscribe((text) => {
            this.popupService.openErrorPopup(text);
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
        console.log(err.message);
      }
    );
  }

  zusammenfassungKorrektur() {
    this.korrektur = true;
  }

  varianteWeiterDisabled(): boolean {
    return !this.variantenHvComponent?.produktart.value ||
      this.variantenHvComponent?.produktart.value === HeimvorteilProduktart.Haushalt &&
      !this.variantenHvComponent?.gebaeudeart.value;
  }

  varianteWeiterClick(): void {
    if (!this.varianteWeiterDisabled()) {
      this.variantPanel.close();
    }
  }

  varianteZueruckClick(): void {
    this.variantPanel.open();
  }

  showBottomButtons(): boolean {
    return !this.varianteWeiterDisabled() && !this.variantPanel.expanded;
  }

  angebotClick(stepper: MatStepper): void {
    if (!((this.erhoehungHoechsthaftungssummeEigenheimGroup.valid || this.erhoehungHoechsthaftungssummeEigenheimGroup.disabled)
      && (this.erhoehungHoechsthaftungssummeNebengebaeudeGroups.valid || this.erhoehungHoechsthaftungssummeNebengebaeudeGroups.disabled )
      && (this.erhoehungHoechsthaftungssummeHaushaltGroup.valid || this.erhoehungHoechsthaftungssummeHaushaltGroup.disabled))) { return; }
    stepper.selectedIndex = 4;
  }

  antragClick(stepper: MatStepper): void {
    if (!((this.erhoehungHoechsthaftungssummeEigenheimGroup.valid || this.erhoehungHoechsthaftungssummeEigenheimGroup.disabled)
      && (this.erhoehungHoechsthaftungssummeNebengebaeudeGroups.valid || this.erhoehungHoechsthaftungssummeNebengebaeudeGroups.disabled )
      && (this.erhoehungHoechsthaftungssummeHaushaltGroup.valid || this.erhoehungHoechsthaftungssummeHaushaltGroup.disabled))) { return; }

    if(!this.offertAntrag && !this.verifyOffert){
      stepper.selectedIndex = 5;
    }else{
      stepper.selectedIndex = 4;
    }

  }

  nextClick(stepper: MatStepper): void {
    stepper.linear = false;
    stepper.selectedIndex = stepper.selectedIndex + 1;
    setTimeout(() => {
      stepper.linear = true;
    });
  }

  datenWeiterDisabled(): boolean {

    if(this.variantFormGroup.valid && !this.maxVersicherungsSummeUeberschritten) {
      if (
        ((this.variantenHvComponent?.produktart.value === HeimvorteilProduktart.Eigenheim ||
          this.variantenHvComponent?.produktart.value === HeimvorteilProduktart.Buendel ) ||
        (this.variantenHvComponent?.produktart.value === HeimvorteilProduktart.Haushalt &&
        this.variantenHvComponent.gebaeudeart.value === HeimvorteilGebaeudeart.Wohnung || this.variantenHvComponent.gebaeudeart.value === HeimvorteilGebaeudeart.Haus)) &&
        (this.variantenHvComponent?.produktart.value === HeimvorteilProduktart.Eigenheim ||
          (this.variantenHvComponent?.produktart.value === HeimvorteilProduktart.Buendel || this.variantenHvComponent?.produktart.value === HeimvorteilProduktart.Haushalt) &&
          this.calculateHvDatenComponent.staendigBewohnt.value === 'ja'
        )
      ) {
        return false;
      }
    }
    return true;
  }

  getProduktName() {
    switch (this.variantenHvComponent?.produktart.value) {
      case HeimvorteilProduktart.Eigenheim:
        return 'Eigenheim';
      case HeimvorteilProduktart.Haushalt:
        switch (this.variantenHvComponent?.gebaeudeart.value){
          case HeimvorteilGebaeudeart.Wohnung:
            return 'Haushalt (Wohnung)';
          case HeimvorteilGebaeudeart.Haus:
            return 'Haushalt (Haus)';
          default:
            return null;
        }
      case HeimvorteilProduktart.Buendel:
        return 'Eigenheim mit Haushalt';
      default:
        return null;
    }
  }

  getProduktArt(): ProduktArt {
    switch (this.variantenHvComponent?.produktart.value) {
      case HeimvorteilProduktart.Eigenheim:
        return ProduktArt.Eigenheim;
      case HeimvorteilProduktart.Haushalt:
        return ProduktArt.Haushalt;
      case HeimvorteilProduktart.Buendel:
        return ProduktArt.Buendel;
      default:
        return null;
    }
  }

  getPraemieZahlungsart() {
    if (this.zahlungsart.value) {
      return this.zahlungsart.value.Key === '1' ? this.hvResult.Gesamt :
        this.zahlungsart.value.Key === '2' ? this.hvResult.Halbjahrespraemie :
          this.zahlungsart.value.Key === '3' ? this.hvResult.Vierteljahrespraemie :
            this.zahlungsart.value.Key === '4' ? this.hvResult.Monatspraemie : null;
    }
    return this.hvResult.Gesamt;
  }

  loadHvPakete(): void {
    if (this.variantenHvComponent.produktart.valid &&
      (this.calculateHvDatenComponent.topHaushalt.disabled ||
        this.calculateHvDatenComponent.topHaushalt.valid) &&
      (this.calculateHvDatenComponent.topEigenheim.disabled ||
        this.calculateHvDatenComponent.topEigenheim.valid) &&
      (this.calculateHvDatenComponent.leitungswasserschaedenAusschliessen.disabled ||
        this.calculateHvDatenComponent.leitungswasserschaedenAusschliessen.valid) &&
      this.calculateHvDatenComponent.gebaeudeHochwasserzoneComponent.gebaeudeHochwasserzone.valid &&
      (this.calculateHvDatenComponent.wohnungGarten.disabled ||
        this.calculateHvDatenComponent.wohnungGarten.valid)) {
      this.calculationService.getHvZusatzpakete({
        ProduktArt: this.variantenHvComponent.produktart.value,
        LeitungswasserschaedenAusschliessen: this.calculateHvDatenComponent.leitungswasserschaedenAusschliessen.value ?
          this.calculateHvDatenComponent.leitungswasserschaedenAusschliessen.value === 'ja' ? true : false : null,
        TopEigenheim: this.calculateHvDatenComponent.topEigenheim.value ? this.calculateHvDatenComponent.topEigenheim.value === 'ja' ? true : false : null,
        TopHaushalt: this.calculateHvDatenComponent.topHaushalt.value ? this.calculateHvDatenComponent.topHaushalt.value === 'ja' ? true : false : null,
        GebaeudeHochwasserzone: this.calculateHvDatenComponent.gebaeudeHochwasserzoneComponent.gebaeudeHochwasserzone.value === 'ja' ? true : false,
        WohnungGarten: this.calculateHvDatenComponent.wohnungGarten.value ? this.calculateHvDatenComponent.wohnungGarten.value === 'ja' ? true : false : null
      }).subscribe(
        data => {
          this.hvHaushaltPakete.next(data.HaushaltPakete);
          this.hvEigenheimPakete.next(data.EigenheimPakete);
        },
        (err: HttpErrorResponse) => {
          this.popupService.openErrorPopup(this.messageService.generateErrorMessage(ErrorMessageType.General));
          console.log(err.message);
        }
      );
    }
  }

  onCalculateRatePending() {
    this.calculateRatePending = true;
    this.resetPdfData();
    this.maxVersicherungsSummeUeberschritten = false;
    this.praemienStatus.resetPraemie();
  }

  onLoadHvPaketePending() {
    this.ref.detectChanges();
    this.loadPakets$.next();
  }

  stepChanged(event) {
    if (event.selectedIndex === 3 && this.calculateRatePending) {
      this.calculateRate$.next();
    }
  }

  datenWeiterClick() {
    if (!this.datenWeiterDisabled()) {
      if (this.firstFormGroup.valid && this.variantFormGroup.valid) {
        this.calculateRate$.next({ precalc: true });
      }
    }
  }

  berechnenClick() {
    if ((this.erhoehungHoechsthaftungssummeEigenheimGroup.disabled ||
      this.erhoehungHoechsthaftungssummeEigenheimGroup.valid) &&
      this.erhoehungHoechsthaftungssummeNebengebaeudeGroups.valid &&
      (this.erhoehungHoechsthaftungssummeHaushaltGroup.disabled ||
        this.erhoehungHoechsthaftungssummeHaushaltGroup.valid) &&
      this.calculateRatePending) {
      this.calculateRate$.next();
    }
  }

  antragWeiterDisabled() {
    return !this.fourthFormGroup.valid;
  }

  onAuswahlAendern() {
    this.variantPanel.close();
  }
}
